exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/AINSA WEB/Documents/proyects/ROUTEMEE/routemee-web-application/src/app/components/modals/asignar-compania-empleado/asignar-compania-empleado.component.css
// module id = ../../../../../src/app/components/modals/asignar-compania-empleado/asignar-compania-empleado.component.css
// module chunks = main